import React, { useState, useEffect } from 'react'
import moment from 'moment'

export default function AirtableIntegration({ airtable }) {
  const [events, setEvents] = useState([])

  const serialize = function (obj, prefix) {
    var str = [],
      p
    for (p in obj) {
      if (obj.hasOwnProperty(p)) {
        var k = prefix ? prefix + '[' + p + ']' : p,
          v = obj[p]
        str.push(
          v !== null && typeof v === 'object'
            ? serialize(v, k)
            : encodeURIComponent(k) + '=' + encodeURIComponent(v),
        )
      }
    }
    return str.join('&')
  }

  useEffect(() => {
    ;(async function () {
      try {
        const params = {}
        if (airtable.sort?.field.length > 0) {
          params.sort = [airtable.sort]
        }
        if (airtable.view.length > 0) {
          params.view = airtable.view
        }
        let res = await fetch(`${airtable.link}&${serialize(params)}`)
        const json = await res.json()
        setEvents(
          json.records.filter((item) =>
            item.fields['Location'].includes('Lunchbox Acoustic'),
          ),
        )
      } catch (err) {
        console.error(err)
        throw err
      }
    })()
  }, [])
  return (
    <div className='container'>
      {events?.length > 0 && (
        <div className='at-grid'>
          {events.map((item) => {
            let time = item.fields['Gig Date/Time']
            let link = item.fields['Ticket/Event Link']
            let genre = item.fields['Genre (If Music)']
            let title = item.fields['Gig Title']

            return (
              <>
                <div className='at-item' key={item.id}>
                  <div className='at-item__genre'>{genre?.join(' ')}</div>
                  <div className='at-item__name'>{title}</div>
                  <div className='at-item__date'>
                    {moment(time).format('MMM Do YYYY')}
                  </div>
                  <div className='at-item__time'>
                    {moment(time).format('h:mm a')}
                  </div>
                  {link?.length > 0 && (
                    <div className='mt-16'>
                      <a
                        href={link}
                        target='_blank'
                        className='btn btn-small-white'>
                        More information
                      </a>
                    </div>
                  )}
                </div>
              </>
            )
          })}
        </div>
      )}
    </div>
  )
}
